// 2 Short Street, Double Bay

export const heroStats = [
  { value: '$1,350', label: '$/sqm' },
  { value: '$3,048', label: 'Double Bay Market Rate' },
  { value: '54%', label: 'Below Market' },
  { value: '5+5', label: 'Year Lease Terms' },
]

export const subjectProperty = {
  address: '2 Short Street',
  tradingAddress: '3 Goldman Lane',
  suburb: 'Double Bay NSW 2028',
  siteArea: 615.9,
  tenancyArea: 177,
  recreationalArea: 158,
  totalArea: 265,
  daReference: 'DA 142/2019',
  daApproved: '17/06/2019',
  approvedUse: 'Recreational Facility (Indoor) - Class 9b',
  offeredRate: 1350,
  offeredAnnual: 245000,
  leaseTerm: '5+5 years',
}

// Double Bay Comps
export const doubleBayComparables = [
  { tenant: 'Bang and Olufsen', sqm: 220, baseRent: 669836, rate: 3045, outgoings: 51792, grossRent: 721628, grossRate: 3280, leaseStart: '15/01/2023', expiry: '14/01/2024', termLength: '5Y', increase: '4%' },
  { tenant: 'Rob\'s House', sqm: 382, baseRent: 695000, rate: 1819, outgoings: 89930, grossRent: 784930, grossRate: 2055, leaseStart: '1/5/25', expiry: '30/04/2030', termLength: '5Yx5Y', increase: '5%' },
  { tenant: 'Llyan Toma Pty Ltd', sqm: 38.1, baseRent: 67954, rate: 1784, outgoings: 8970, grossRent: 76924, grossRate: 2019, leaseStart: '1/10/23', expiry: '30/09/2024', termLength: '5Yx5', increase: '4%' },
  { tenant: 'The World of Whisky', sqm: 60, baseRent: 121485, rate: 2025, outgoings: 14125, grossRent: 135611, grossRate: 2260, leaseStart: '1/9/21', expiry: '31/08/2026', termLength: '5Y', increase: '4%' },
  { tenant: 'Bartiga', sqm: 84, baseRent: 251804, rate: 2928, outgoings: 20246, grossRent: 272050, grossRate: 3163, leaseStart: '1/10/23', expiry: '30/09/2031', termLength: '10Y', increase: '4%' },
  { tenant: 'Al Tiramisu', sqm: 195.2, baseRent: 296770, rate: 1520, outgoings: 45954, grossRent: 342720, grossRate: 1756, leaseStart: '1/9/21', expiry: '31/08/2023', termLength: '10Y', increase: '2%' },
  { tenant: 'T & B Gourmet Butchery', sqm: 70.8, baseRent: 142784, rate: 2017, outgoings: 16648, grossRent: 159452, grossRate: 2252, leaseStart: '10/4/19', expiry: '9/4/24', termLength: '7Y', increase: '5%' },
  { tenant: 'Bartuja', sqm: 86, baseRent: 268732, rate: 3125, outgoings: 20246, grossRent: 288980, grossRate: 3360, leaseStart: '1/1/23', expiry: '31/12/2030', termLength: '8Y', increase: '3%' },
  { tenant: 'Michael\'s Charcuterie', sqm: 88.5, baseRent: 268732, rate: 3037, outgoings: 20835, grossRent: 289566, grossRate: 3272, leaseStart: '31/01/2021', expiry: '30/01/2029', termLength: '8Y', increase: '2%' },
  { tenant: 'Kikono\'s Cosmetics', sqm: 160.5, baseRent: 416099, rate: 2592, outgoings: 37788, grossRent: 453880, grossRate: 2828, leaseStart: '1/10/19', expiry: '30/09/2024', termLength: '7Y', increase: '4%' },
  { tenant: 'Bassline Retail', sqm: 104.7, baseRent: 332273, rate: 3174, outgoings: 24648, grossRent: 356921, grossRate: 3409, leaseStart: '1/9/21', expiry: '31/08/2024', termLength: '5Y', increase: '4%' },
  { tenant: 'Accent Acting Pty Ltd', sqm: 220, baseRent: 497392, rate: 2261, outgoings: 51792, grossRent: 549180, grossRate: 2496, leaseStart: '7/10/21', expiry: '6/11/24', termLength: '5Y', increase: '3%' },
  { tenant: 'Blanca Spender', sqm: 56.3, baseRent: 163909, rate: 3174, outgoings: 13254, grossRent: 191926, grossRate: 3409, leaseStart: '18/11/2021', expiry: '17/11/2024', termLength: '5Y', increase: '4%' },
  { tenant: 'The Eve Smaller', sqm: 118, baseRent: 349595, rate: 2962, outgoings: 27787, grossRent: 377382, grossRate: 3197, leaseStart: '', expiry: '31/05/2027', termLength: '7Y', increase: '3%' },
  { tenant: 'Hannah Art Wear', sqm: 51.5, baseRent: 163909, rate: 3183, outgoings: 12124, grossRent: 176033, grossRate: 3418, leaseStart: '1/4/22', expiry: '31/01/2029', termLength: '6Y', increase: '3%' },
  { tenant: 'Bayview Natural Health', sqm: 92.6, baseRent: 163200, rate: 1762, outgoings: 21800, grossRent: 185000, grossRate: 1998, leaseStart: '15/02/2025', expiry: '14/02/2030', termLength: '5Y', increase: '4%' },
  { tenant: 'Young\'s Best Tailor', sqm: 26.4, baseRent: 51601, rate: 1955, outgoings: 6215, grossRent: 57816, grossRate: 2190, leaseStart: '13/08/2014', expiry: '14/08/2019', termLength: '5Y', increase: 'na' },
  { tenant: 'Double Bay Cigar', sqm: 23.5, baseRent: 74793, rate: 3183, outgoings: 5532, grossRent: 80326, grossRate: 3418, leaseStart: '15/05/2022', expiry: '14/05/2029', termLength: '7Y', increase: '3%' },
  { tenant: 'AL Jewellery', sqm: 12.5, baseRent: 41155, rate: 3292, outgoings: 2943, grossRent: 44098, grossRate: 3528, leaseStart: '11/1/14', expiry: '10/1/27', termLength: '8Y', increase: 'na' },
  { tenant: 'GF & Lvl 1 2-10 Bay St', sqm: 465, baseRent: 813750, rate: 1750, outgoings: 93000, grossRent: 906750, grossRate: 1950, leaseStart: '1/7/25', expiry: '', termLength: '10Y+5+5', increase: '4%' },
  { tenant: 'UG 2-10 Bay St', sqm: 144, baseRent: 288000, rate: 2000, outgoings: 28800, grossRent: 316800, grossRate: 2200, leaseStart: '1/7/25', expiry: '', termLength: '10Y+10', increase: '4%' },
  { tenant: 'LG 2-10 Bay St', sqm: 318, baseRent: 636000, rate: 2000, outgoings: 63600, grossRent: 699277, grossRate: 2199, leaseStart: '1/7/25', expiry: '', termLength: '10Y+10', increase: '4%' },
  { tenant: 'Shop 1-5 2-22 Knox St', sqm: 220, baseRent: 619300, rate: 2815, outgoings: 39600, grossRent: 658900, grossRate: 2995, leaseStart: '1/1/23', expiry: '', termLength: '10Y+10', increase: 'na' },
  { tenant: 'Shop 22-29 2-22 Knox St', sqm: 220, baseRent: 455400, rate: 2070, outgoings: 39600, grossRent: 495000, grossRate: 2250, leaseStart: '1/1/23', expiry: '', termLength: '10Y+10', increase: 'na' },
  { tenant: 'Shop 18-19 2-22 Knox St', sqm: 161, baseRent: 369150, rate: 2293, outgoings: 28980, grossRent: 398130, grossRate: 2473, leaseStart: '1/1/23', expiry: '', termLength: '10Y+10', increase: 'na' },
  { tenant: 'GF-Lvl 2 24 Bay St', sqm: 767, baseRent: 1575418, rate: 2054, outgoings: 156468, grossRent: 1731886, grossRate: 2054, leaseStart: '1/9/24', expiry: '', termLength: '10Y+10', increase: '4%' },
  { tenant: '21-27 Bay St', sqm: 2986, baseRent: 6375000, rate: 2135, outgoings: 447900, grossRent: 6822900, grossRate: 2285, leaseStart: '1/6/25', expiry: '', termLength: '15Y+5+5+5', increase: '3.25%' },
]

// Private Schools within 5km of 2 Short Street
export const nearbySchools = [
  { name: 'Ascham School', address: '188 New South Head Road, Edgecliff', distance: 1.35, drive: '2.4 min', type: 'Independent | Girls | K-12' },
  { name: 'Cranbrook School', address: '5 Victoria Road, Bellevue Hill', distance: 2.02, drive: '3.5 min', type: 'Independent Anglican | Boys | Pre-K to Year 12' },
  { name: 'The Scots College', address: '29-53 Victoria Road, Bellevue Hill', distance: 2.02, drive: '3.5 min', type: 'Independent Presbyterian | Boys | Early Years to Year 12' },
  { name: 'Reddam House Woollahra', address: '70 Edgecliff Road, Woollahra', distance: 2.20, drive: '4.9 min', type: 'Independent | Co-ed | Preschool to Year 9' },
  { name: 'Kambala School', address: '794 New South Head Road, Rose Bay', distance: 2.35, drive: '3.8 min', type: 'Independent | Girls | ELS to Year 12' },
  { name: 'SCEGGS Darlinghurst', address: '215 Forbes Street, Darlinghurst', distance: 2.78, drive: '4.8 min', type: 'Independent Anglican | Girls | K-12' },
  { name: 'Moriah College', address: '3 Queens Park Road, Queens Park', distance: 2.95, drive: '5.7 min', type: 'Orthodox Jewish | Co-ed | Preschool to Year 12' },
  { name: 'St Vincent\'s College', address: 'Rockwall Crescent, Potts Point', distance: 3.11, drive: '5.3 min', type: 'Catholic | Girls | Year 7-12' },
  { name: 'St Mary\'s Cathedral College', address: '2 St Mary\'s Road, Sydney', distance: 3.27, drive: '5.2 min', type: 'Catholic | Boys | Year 7-12' },
  { name: 'Sydney Grammar School', address: '10 College Street, Darlinghurst', distance: 3.46, drive: '6.0 min', type: 'Independent | Boys | Year 7-12' },
  { name: 'Montessori East', address: '8 Wellington Street, Bondi', distance: 3.57, drive: '6.3 min', type: 'Independent | Co-ed | Preschool to Year 6' },
  { name: 'Waverley College', address: '131 Birrell Street, Waverley', distance: 3.61, drive: '6.2 min', type: 'Catholic | Boys | Year 5-12' },
  { name: 'St Clare\'s College', address: '41-51 Carrington Road, Waverley', distance: 3.63, drive: '6.3 min', type: 'Catholic | Girls | Year 7-12' },
  { name: 'Reddam House Bondi', address: '56 Mitchell Street, Bondi', distance: 4.07, drive: '7.0 min', type: 'Independent | Co-ed | Year 10-12' },
  { name: 'Emanuel School', address: '20 Stanley Street, Randwick', distance: 4.20, drive: '8.4 min', type: 'Jewish | Co-ed | Preschool to Year 12' },
  { name: 'St Andrew\'s Cathedral School', address: '474 Kent Street, Sydney', distance: 4.40, drive: '6.1 min', type: 'Independent Anglican | Co-ed | K-12' },
  { name: 'St Catherine\'s School', address: '26 Albion Street, Waverley', distance: 4.48, drive: '7.8 min', type: 'Independent Anglican | Girls | K-12' },
  { name: 'Kincoppal-Rose Bay', address: '2 Vaucluse Road, Vaucluse', distance: 4.56, drive: '7.9 min', type: 'Catholic | Girls | Prep to Year 12' },
]

// Demographics Comparison
export const demographics = {
  bondi: {
    name: 'Bondi',
    hhIncome: '$98,000',
    netWorth: '$1.4M',
    source: 'https://www.abs.gov.au/census',
    sourceLabel: 'ABS Census 2021',
  },
  doubleBay: {
    name: 'Double Bay',
    hhIncome: '$156,000',
    netWorth: '$4.2M',
    source: 'https://www.abs.gov.au/census',
    sourceLabel: 'ABS Census 2021',
  },
  darlinghurst: {
    name: 'Darlinghurst',
    hhIncome: '$78,000',
    netWorth: '$890K',
    source: 'https://www.abs.gov.au/census',
    sourceLabel: 'ABS Census 2021',
  },
}


// DA Comparison
export const daComparison = {
  doubleBay: {
    location: '2 Short Street, Double Bay',
    status: 'APPROVED',
    reference: 'DA 142/2019',
    council: 'Woollahra Municipal Council',
    approvalDate: '17 June 2019',
    use: 'Recreational Facility (Indoor)',
    class: '9b',
    capacity: '12 PAX with DA and BCA (DDA WC / Fire etc)',
    risk: 'None - approved',
  },
  bondi: {
    location: 'Bondi (current)',
    status: 'Retail',
    reference: null,
    council: 'Waverley Council',
    approvalDate: null,
    use: 'Not approved',
    class: null,
    capacity: '8-10 people max',
    risk: '?',
    rent: '$10,000/mo',
  },
  option: 'Scenario Analysis',
}

// Lease Terms
export const leaseTerms = {
  term: '5 years initial',
  option: '5 years',
  totalCommitment: '10 years',
  escalation: '3.5% fixed',
  incentive: '3 months rent-free',
  makeGood: 'NA',
  fiveYearProjection: [
    { year: 1, rent: 245000 },
    { year: 2, rent: 253575 },
    { year: 3, rent: 262450 },
    { year: 4, rent: 271636 },
    { year: 5, rent: 281143 },
  ],
  totalFiveYear: 1313804,
}
